import React from 'react';
import {inject, observer} from 'mobx-react';
import { Modal } from 'antd';
import LoginContent from './LoginContent';

@inject('initStore')
@observer
class Root extends React.Component {

  componentWillMount() {
    const { openLogin, closeLogin } = this.props.initStore;
    window.openLogin = typeof openLogin === 'function' ? openLogin : () => {};
    window.closeLogin = typeof closeLogin === 'function' ? closeLogin : () => {};
  }

  render() {
    const {
      isEclogin,
      initStore: { loginVisible, closeLogin }
    } = this.props;
    return (
      <Modal
        visible={loginVisible}
        onCancel={closeLogin}
        width={402}
        footer={null}
        maskClosable={false}
        style={{ top: 160 }}
        bodyStyle={{
          height: 395
        }}
      >
        <LoginContent isModal={true} isEclogin={isEclogin}/>
      </Modal>
    )
  }
}

export default Root;


// WEBPACK FOOTER //
// ./src/components/init/LoginModal.js